<div class="main-header" [style.background-color]="background" [style.color]="foreground">
    <div class="flex flex-row container">

        <div class="container brand flex-auto ps-0 justify-between">
            <a class="logo  flex-shrink-0" routerLink="/">
                <img src="assets/svg/logo-main.svg">
            </a>

            <!-- <div class="separator"></div> -->

            <!-- <button type="button" class="country-btn" (click)="countries.length > 1? languageDropdown.toggle() : citiesModal(countries[0])">
                <img [src]="currentFlag">
            </button> -->

            <!-- <div class="nav-links__item-body">
                {{ 'sectors'|translate }}
                <app-icon  class="nav-links__item-arrow mx-1" name="arrow-rounded-down-9x6" size="9x6"></app-icon>
            </div> -->
            @if(location()=='homepage' || location()=='rfq'){
                <div class="search mobile:hidden">
                <app-search location="header"></app-search>
            </div>



            <div class="flex flex-row gap-3">
                <div class="topbar__item">
                    <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened" #sectorsDropdown="appDropdown">
                        <button class="topbar-dropdown__btn font-semibold text-default-blue" type="button" (click)="toggleSectors()">
                            {{ 'categories'|translate }}
                            <app-icon name="arrow-rounded-down-7x5" size="7x5"></app-icon>
                        </button>

                        <div class="topbar-dropdown__body _sector">
                            <div class="rounded-2xl">
                                <app-sectors-menu (hasSelected)="sectorsDropdown.close()"></app-sectors-menu>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="topbar__item mobile:hidden">
                    <div class="relative">
                        @if(notifications()?.quote){
                        <div class="w-2 h-2 rounded-full absolute bg-[#ff5050] rtl:left-3 ltr:right-3 top-0">
                        </div>
                        }
                        <button class="topbar-dropdown__btn font-semibold text-default-blue rfq-center-btn" type="button" 
                            [routerLink]="['rfq/center']">
                            {{ 'rfq_center'|translate }}
                        </button>
                    </div>
                </div>

                <div class="topbar__item mobile:hidden">
                    <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened" #sectorsDropdown="appDropdown">
                        <!-- <button class="topbar-dropdown__btn font-semibold text-default-blue" type="button"
                            [routerLink]="['/',translateService.currentLang,'category','real-estate']">
                            {{ 'real_estate'|translate }}
                        </button> -->
                        <!-- <div class="indicator-item d-none d-lg-block" *ngIf="!siteService.siteSetting?.companyId">
                            <a routerLink="/apply-for-vendor" class="become-vendor-link">{{"become_vendor"|translate}}</a>
                        </div> -->
                        <button class="topbar-dropdown__btn font-semibold text-default-blue" type="button" [routerLink]="['/apply-for-vendor']">
                            {{ 'become_vendor'|translate }}
                        </button>
                    </div>
                </div>

                @if(siteService.features?.professionals){
                <div class="topbar__item mobile:hidden">
                    <button class="topbar-dropdown__btn font-semibold text-default-blue" type="button" [routerLink]="['/site/professionals']">
                        {{ 'professionals'|translate }}
                    </button>
                </div>
                }
            </div>

            }
        </div>

         

        <div class="nav {{location()}}">

            
             


            <div class="indicator-item">
                <app-indicator link="./account" iconClass="text-default-blue text-3xl w-8 h-8" fontSet="material_icons" matIcon="person" trigger="click" title="Account" size="24" #indicator1="appIndicator">
                    <app-account-menu (closeMenu)="indicator1.close(false)"></app-account-menu>
                </app-indicator>
            </div>
            @if(location()=='homepage' || location()=='rfq'){
            <!-- <div *ngIf="siteService.features?.quotationRequests" class="indicator-item">
                <app-indicator class="quote" [routerLink]="['rfq/dashboard']" svgIcon="quotations_new" size="24"
                    title="Quotations" trigger="click" #indicator3="appIndicator">
                </app-indicator>
            </div> -->

            

            <div class="indicator-item">
                <app-indicator class="cart " [routerLink]="['cart']" link="./cart" iconClass="text-default-blue text-3xl w-8 h-8" fontSet="material_icons" matIcon="shopping_cart" trigger="click" title="Cart" [counter]="cart.quantity$|async" #indicator="appIndicator">
                    <!--  <app-header-dropcart *ngIf="dropcartType == 'dropdown'" (closeMenu)="indicator.close(false)">
                    </app-header-dropcart> -->
                </app-indicator>
            </div>

           

            <div class="language-switcher ">
                <button 
                    class="language-btn active sm-tablet:hidden" 
                    (click)="translateService.currentLang == 'ar' ? changeLangage('en') : changeLangage('ar')"
                    type="button">
                    {{ translateService.currentLang == 'ar' ? 'AR' : 'EN' }}
                </button>
            </div>

            <div class="indicator-item sm-tablet:hidden">
                <app-country-select variant="header"></app-country-select>
            </div>

            

            <!--   <div class="indicator-item p-0">
            
                <button class="bg-transparent border-0" style="color: inherit;"
                    (click)="translateService.currentLang == 'ar'? changeLangage('en'): changeLangage('ar')">{{translateService.currentLang
                    == 'ar'? 'English' : 'العربية'}}</button>
            </div> -->

            <!--   <div class="indicator-item">
                <app-indicator [image]="currentFlag" [imageClass]="'rounded-full'" class="rounded-full country"
                    size="45" trigger="click"
                    (buttonClick)="countries.length > 1? languageDropdown.toggle() : citiesModal(countries[0])"
                    #indicator4="appIndicator">
                </app-indicator>
                <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened" #languageDropdown="appDropdown">

                    <div class="topbar-dropdown__body mx-3">
                        <div *ngIf="countries?.length == 0 || !countries"
                            class="menu menu--layout--topbar menu--with-icons justify-center">
                            <mat-spinner [diameter]="48"></mat-spinner>
                        </div>

                        <div class="menu menu--layout--topbar menu--with-icons">
                            <ul class="menu__list">
                                <li class="menu__item" *ngFor="let country of countries"
                                    (mouseover)="menuItem.classList.add('menu__item--hover')"
                                    (mouseleave)="menuItem.classList.remove('menu__item--hover')" #menuItem>
                                    <button class="menu__item-link" type="button"
                                        (click)="changeCountry(country, languageDropdown)">
                                        <span class="menu__item-icon">
                                            <img *ngIf="country.code =='BHR' || country.code == 'KSA'" width="28"
                                                [src]="'assets/images/flags/'+country.code+'.png'">
                                        </span>
                                        {{ translateHelper.localize(country.name) }}
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div *ngIf="currentCountry && countries.includes(currentCountry)"
                            class="menu menu--layout--topbar menu--with-icons"></div>
                    </div>
                </div>
            </div> -->

            <!--  <button type="button" class="country-btn w-5" style="width: 1.75rem; height: 1.75rem;" (click)="countries.length > 1? languageDropdown.toggle() : citiesModal(countries[0])">
            <img [src]="currentFlag">
        </button> -->

            <!--     <div class="indicator-item d-none d-lg-block" *ngIf="currentUser?.isVendor; else becomeVendor">
                <a href="/admin" target="_blank" class="become-vendor-link">{{"admin_panel"|translate}}</a>
            </div>
            <ng-template #becomeVendor>
                <div class="indicator-item d-none d-lg-block" *ngIf="!siteService.siteSetting?.companyId">
                    <a routerLink="/apply-for-vendor" class="become-vendor-link">{{"become_vendor"|translate}}</a>
                </div>
            </ng-template> -->
            }
            <!-- @if(location()=='rfq'){
            <button class="primary-button me-4" [routerLink]="['/', translateService.currentLang, 'rfq', 'request']">
                <div class="label">{{"get_quotation"|translate}}</div>
            </button>
            <button class="primary-button" [routerLink]="['/', translateService.currentLang, 'rfq', 'requests']">
                <div class="label">{{"view_requests"|translate}}</div>
            </button>
            
            } -->
        </div>

    </div>

</div>
<!-- <app-sector-and-categories></app-sector-and-categories> -->